module.exports = __webpack_public_path__ + "img/chainsafe.b05898cb.svg";